import styled from 'styled-components';

const HomePageHolder = styled.div`
	display: block;
	background-attachment: fixed;
	grid-area: content;
	overflow: hidden;
	width: 100%;
	margin: 0 auto;
	min-height: 600px;
	h1 {
		position: relative;
		background-color: rgb(60, 63, 71);
		color: white;
		font-size: 24px;
		width: 100%;
		left: 0;
		padding-left: 25px;
		min-height: 50px;
		line-height: 50px;
	    margin-top: 0px;
		margin-bottom: 0px;
		text-indent: 35px;
		font-family: 'Quicksand', sans-serif;
		font-weight: 500;
	}
	.feature__title {
		color: #fdfdfc;
		font-family: 'Quicksand', sans-serif;
		display: flex;
		justify-content: space-between;
		background: #5f7586 url(/static-assets/theme/svg/left-decoration.svg) center left -2px no-repeat;
		background-size: auto 110%;
		padding: 8px 20px 8px 40px;
		border-radius: 2em;
		border: 0;
		text-transform: uppercase;
		margin: 25px 0px 20px 0px;
		font-size: 24px;
	}

	@media only screen and (max-width: 920px) {
		.content { 
			display: flex;
			flex-direction: column;
			&__left {
				order: 1;
			}
			&__right {
				order: 2;
			}
			&__full {
				order: 3;
			}
		}
	}
`;

export default HomePageHolder;